import styled from 'styled-components'

import { NEUTRAL_COLOURS } from 'constants/colors'

export const StyledFieldWrapper = styled.div`
  max-width: 450px;
`

export const StyledCarerContainer = styled.div`
  margin: 16px 0;
  border-radius: 8px;
  padding: 16px;
  background-color: ${NEUTRAL_COLOURS.GRAY_QUATERNARY};
  display: grid;
  gap: 16px;
`

export const StyledCarerItemContainer = styled.div`
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 20px;
  align-items: start;
`

export const StyledCarerContact = styled.div`
  display: grid;
  gap: 5px;
`

export const StyledCarerContactItem = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px;
  align-items: center;
`
